module.exports = __webpack_public_path__ + "img/logoWithText.7ccc4800.png";